<ng-container *ngIf="mfaChallenge$ | async">
  <div class="mfa-verification-form text-center" data-testing-id="mfa-verification">
    <h2>{{ 'account.login.otp.heading' | translate }}</h2>
    <p class="text-muted">{{ 'account.login.otp.description' | translate }}</p>
    <p class="small text-muted mb-1">{{ 'account.login.otp.validity' | translate }}</p>
    <p class="small text-muted" data-testing-id="otp-demo-hint">{{ 'account.login.otp.demo_hint' | translate }}</p>

    <ish-error-message [error]="mfaError$ | async" [toast]="false" />

    <form novalidate autocomplete="off" [formGroup]="form" (ngSubmit)="verify()">
      <div class="prs-autofill-decoy" aria-hidden="true">
        <input type="text" name="username" tabindex="-1" autocomplete="username" />
        <input type="password" name="password" tabindex="-1" autocomplete="current-password" />
      </div>
      <div class="form-group mb-3">
        <span class="d-block mb-2">{{ 'account.login.otp.label' | translate }}</span>
        <ish-mfa-otp-input [length]="otpLength" [formControl]="otpControl" />
      </div>

      <div class="form-check text-start mb-3" data-testing-id="mfa-trust-device">
        <input
          class="form-check-input"
          type="checkbox"
          id="prsMfaTrustDevice"
          [checked]="trustDevice"
          (change)="onTrustChange($event)"
        />
        <label class="form-check-label" for="prsMfaTrustDevice">{{
          'account.login.otp.trust_device' | translate
        }}</label>
      </div>

      <div class="form-group">
        <button type="submit" class="btn btn-primary px-4" [disabled]="otpControl.invalid || (mfaVerifying$ | async)">
          {{ 'account.login.otp.verify.button.label' | translate }}
        </button>
      </div>
    </form>

    <div class="form-group mt-3">
      <span>{{ 'account.login.otp.resend.question' | translate }}</span>
      <button type="button" class="btn btn-link" [disabled]="mfaResending$ | async" (click)="resend()">
        {{ 'account.login.otp.resend.button.label' | translate }}
      </button>
    </div>

    <div class="form-group">
      <button type="button" class="btn btn-link" (click)="backToLogin()">
        {{ 'account.login.otp.back_to_login.label' | translate }}
      </button>
    </div>
  </div>
</ng-container>
